module.exports = __webpack_public_path__ + "media/images/logo-green-fb597c16.svg";